module.exports = __webpack_public_path__ + "static/media/SeaBgAOD.3e4acab7.svg";